// extracted by mini-css-extract-plugin
export var assigneeBadge = "_m8-0";
export var assigneeDetails = "_m8-1";
export var assigneeInfo = "_m8-2";
export var dropdownContainer = "_m8-4";
export var dropdownImage = "_m8-5";
export var editAssigneeInfo = "_m8-3";
export var editAssigneeModalContainer = "_m8-6";
export var hidden = "_m8-8";
export var input = "_m8-7";